import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import Icon from 'utility/icomoon';
import useGetEventActivityDropdown from '../../../views/screens/Reports/hooks/useGetEventActivityDropdown';
import MultiSelectInput from '../MultiSelectInput';

const EventsDropdown = (props) => {
  const {
    eventsFilters,
    forceinitialvalue,
    useLabel = true,
    placeholder,
    isClearable = false,
    isMultiple = false,
    isInModal = false,
    id,
    name,
    ...inputProps
  } = props;
  const { eventTypes, isFetchingEventTypes } = useGetEventActivityDropdown(
    eventsFilters?.organizationId
  );
  const intl = useIntl();

  //Reset value with initial when values are loaded from db
  const [resetValue, setResetValue] = useState(Date.now());
  // const resetDropdown = () => {
  //   setResetValue(Date.now());
  // };
  const resetDropdown = () => {
    inputProps.field.onChange(forceinitialvalue);
    setResetValue(Date.now());
  };

  //Update reactselect values of  units when fetched is finished
  useEffect(() => {
    if (!isFetchingEventTypes) {
      resetDropdown();
    }
  }, [isFetchingEventTypes, props?.options?.length]);

  const [selectedEvents, changeSelectedEvents] = useState<any>('');

  return (
    <>
      <MultiSelectInput
        {...inputProps}
        id={id}
        key={resetValue}
        name={name}
        isLoading={isFetchingEventTypes}
        isClearable={isClearable}
        componentKey={resetValue}
        isInModal={isInModal}
        isMultiple={isMultiple}
        onSelect={(event) => {
          if (event) {
            if (isMultiple) {
              var string = '';
              event.map((email) => (string = string + email.value + ','));
              changeSelectedEvents(string.slice(0, -1));
            } else {
              changeSelectedEvents(event.value);
            }
          } else {
            // changeSelectedUsers(null);
          }
        }}
        selectedValues={selectedEvents}
        type={'select'}
        options={
          props.options ||
          eventTypes.map((eventType) => ({
            id: eventType.eventId,
            value: eventType.eventId,
            label: intl.formatMessage({ id: `organizations.event${eventType.eventId}` }),
            label_intl: intl.formatMessage({ id: `organizations.event${eventType.eventId}` }),
            icon: (
              <div
                className="d-flex align-items-center justify-content-center"
                style={{
                  background: 'white',
                  width: 26,
                  height: 26,
                  padding: 3,
                  borderRadius: '100%',
                  borderStyle: 'solid',
                  borderColor: `#${
                    eventType.eventPrimaryColor !== null &&
                    eventType.eventPrimaryColor?.trim() !== '' &&
                    eventType.eventPrimaryColor?.trim() !== 'FFFFFF'
                      ? eventType.eventPrimaryColor
                      : '000000'
                  }`
                }}
              >
                <Icon
                  icon={`Alert-${eventType.eventId}`}
                  size={20}
                  color={`#${eventType.eventColor}`}
                />
              </div>
            )
          }))
        }
        label={
          useLabel
            ? props.label ||
              intl.formatMessage({
                id: 'reports.event'
              })
            : null
        }
        //defaultValue={defaultEvents}
        placeholder={placeholder || intl.formatMessage({ id: 'reports.selectEvent' })}
      />
    </>
  );
};

EventsDropdown.defaultProps = {};

export default EventsDropdown;
